import { handleResult, postForm } from '../http';

// A row on Product/Index. `active` works with the shared statusDialog; `homepage`
// marks the one product shown on the homepage, which the server lets us change.
export const productRow = (id) => ({
  id,
  active: null,
  homepage: true,
  busy: false,

  // Another row became the homepage product.
  onHomepageChanged(event) {
    this.homepage = event.detail.id === this.id;

    if (this.homepage) {
      this.active = event.detail.isActive;
    }
  },

  async makeHomepage() {
    this.busy = true;

    try {
      const response = await postForm('/product/SetAsHomepageProduct', { productId: this.id });
      handleResult(response, (data) => {
        window.dispatchEvent(new CustomEvent('homepage-changed', { detail: { id: this.id, isActive: data.isActive } }));
      });
    } catch (error) {
      console.error(error);
      window.showErrorMessage('Something went wrong, please try again.');
    } finally {
      this.busy = false;
    }
  },
});
